import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import AuthReducer from './reducers/Auth';
import PAEAA010Reducer from './reducers/PAEAA010';
import PAEAA014Reducer from './reducers/PAEAA014';
import PAFAA010Reducer from './reducers/PAFAA010';
import dataPAJAC020 from './reducers/PAJAC020';

const persistConfigAuth = {
    key: 'dentaljob-pdsoft-auth',
    storage,
};

const persistConfig = {
    key: 'dentaljob-pdsoft',
    storage,
};

const persistedAuthReducer = persistReducer(persistConfigAuth, AuthReducer);
const persistedPAEAA010Reducer = persistReducer(persistConfig, PAEAA010Reducer);
const persistedPAEAA014Reducer = persistReducer(persistConfig, PAEAA014Reducer);
const persistedPAFAA010Reducer = persistReducer(persistConfig, PAFAA010Reducer);
const persistedDataPAJAC020Reducer = persistReducer(persistConfig, dataPAJAC020);

const store = configureStore({
    reducer: {
        auth: persistedAuthReducer,
        PAEAA010: persistedPAEAA010Reducer,
        PAEAA014: persistedPAEAA014Reducer,
        PAFAA010: persistedPAFAA010Reducer,
        PAJAC020: persistedDataPAJAC020Reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);
export default store;
